import React from 'react';
import { useQrDepositeModal } from '../recoil/hooks/useModalState';
import QrDepositeModalTailwind from '../components/common/QrDepositeModalTailwind';

export default function ModalWrap() {
  const [qrOpen, setQrOpen] = useQrDepositeModal();

  return (
    <div className=' relative'>

      {/* Modals will be rendered here */}
      <div
        className=' fixed top-0 left-0 w-full h-full z-50 flex items-center justify-center pointer-events-none '>
        {/* {qrOpen && (
          <QrDepositeModalTailwind />
        )} */}
      </div>

    </div>
  );
}
